import React, { FC, useState, useRef } from "react";
import cx from "classnames";
import styles from "./customTooltip.module.scss";

export enum CustomTooltipType {
  SRP_GRID_PRICE = "srp_GRID_price",
  SRP_GRID_PROPERTY = "srp_GRID_property",
  SRP_ROW_PROPERTY = "SRP_ROW_property",
  VDP_PRICE_DETAILS = "vdp_price_details",
}

interface ICustomTooltip {
  title: string;
  target: JSX.Element;
  type?: CustomTooltipType;
}

const CustomTooltip: FC<ICustomTooltip> = ({ title, target, type }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef<any>(null);
  const toggleRef = React.useRef<any>(null);

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  const handleClickOutside = (event: any) => {
    if (
      tooltipRef.current &&
      !tooltipRef.current.contains(event.target) &&
      toggleRef.current &&
      !toggleRef.current.contains(event.target)
    ) {
      setShowTooltip(false);
    }
  };

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={cx(styles.tooltipContainer, {
        [styles.srp_grid_price]: type === CustomTooltipType.SRP_GRID_PRICE,
        [styles.srp_grid_property]: type === CustomTooltipType.SRP_GRID_PROPERTY,
        [styles.srp_row_property]: type === CustomTooltipType.SRP_ROW_PROPERTY,
        [styles.vdp_price_details]: type === CustomTooltipType.VDP_PRICE_DETAILS,
        [styles.showTooltip]: showTooltip,
      })}
    >
      <div className={styles.tooltipAnchor} onClick={toggleTooltip} ref={toggleRef}>
        {target}
      </div>
      <div className={styles.customTooltip} ref={tooltipRef}>
        <span title={title}>{title}</span>
      </div>
    </div>
  );
};

export default CustomTooltip;
